export const REQUEST_REJECT_VPA = 'REQUEST_REJECT_VPA';
export const REJECT_VPA_SUCCESS = 'REJECT_VPA_SUCCESS';
export const REJECT_VPA_FAILURE = 'REJECT_VPA_FAILURE';
export const REQUEST_VERIFY_VPA = 'REQUEST_VERIFY_VPA';
export const VERIFY_VPA_SUCCESS = 'VERIFY_VPA_SUCCESS';
export const VERIFY_VPA_FAILURE = 'VERIFY_VPA_FAILURE';
export const REQUEST_FETCH_ALL_VPA = 'REQUEST_FETCH_ALL_VPA';
export const FETCH_ALL_VPA_SUCCESS = 'FETCH_ALL_VPA_SUCCESS';
export const FETCH_ALL_VPA_FAILURE = 'FETCH_ALL_VPA_FAILURE';
